/**
 * CTA animation
 */
class ATS_CtaAnimation {
    constructor() {
        this.initEvents();
    }

    initEvents() {
        let ctaSliderWrapper = $('.animated-cta');

        if (ctaSliderWrapper) {
            let ctaSliderItem = ctaSliderWrapper.find('.animated-news-item');
            let nextBtn = ctaSliderWrapper.find('.next');
            let currentItem = 0;
            let animationInProgress = false;

            setTimeout(() => {
                showNextSlide();
            }, 4500);

            nextBtn.on('click', function(e) {
                e.preventDefault();

                if (animationInProgress) {
                    return;
                }

                currentItem++;
                animationInProgress = true;

                if (currentItem >= ctaSliderItem.length) {
                    currentItem = 0;
                }

                ctaSliderItem.removeClass('is-active');
                ctaSliderItem.eq(currentItem).addClass('is-active');

                setTimeout(function() {
                    animationInProgress = false;
                }, 550);
            });

            function showNextSlide () {
                nextBtn.trigger('click');
    
                setTimeout(() => {
                    showNextSlide();
                }, 4500);
            }
        }
    }
}